<template>
  <div class="app-modal-dialog--screen-rearrangement-overlay app-modal-dialog">
    <div class="app-modal-dialog__content">
      <div class="app-modal-dialog__header">
        <h2 class="app-modal-dialog__title">
            <span class="app-modal-dialog__subtitle">{{ publication.name }}</span>
            Move Screen
        </h2>
        <button type="button" class="element-button--icon element-button" @click="$emit('cancel')" aria-label="Close">
          <svg class="element-icon--x element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-x"></use></svg>
        </button>
      </div>
      <div class="app-modal-dialog__body grid">
        <p class="col-12">Select the "Move to" button to move the selected screen to different Topic.</p>
        <table class="col-12">
          <thead>
            <tr>
              <th>Title</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(topic, topicIndex) in topicSource" :key="topicIndex">
              <td :class="['topic', 'app-accordion', isItemOpen(topicIndex) ? 'is--open' : '']">
                <div class="app-accordion__header" @click="toggleItem(topicIndex)">
                  <svg class="element-icon--chevron-down element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-chevron-down"></use></svg>
                  <h3 class="app-modal-dialog__topic-name-text">
                    Topic: {{ topic.topicName }}
                  </h3>
                </div>
                <table>
                  <thead>
                  </thead>
                  <tbody class="learning-objects app-accordion__body" v-if="isItemOpen(topicIndex)">
                    <tr v-for="(learningObject, loIndex) in topic.learningObjects" :key="loIndex" class="app-accordion__table-row">
                      <td class="app-modal-dialog__lo-name">
                        <h4 class="app-modal-dialog__lo-name-text">
                          {{ learningObject.learningObjectName }}
                        </h4>
                      </td>
                      <td v-if="activeTopic == topicIndex && activeLearningObject == loIndex" class="app-modal-dialog__lo-current-location">
                        <div class="element-badge is--info">Current location</div>
                      </td>
                      <td v-else class="app-modal-dialog__lo-move-to">
                        <app-button class="element-button element-button--secondary" theme="clear" @click="$emit('moveScreen', topicIndex, loIndex, activeScreen); $emit('cancel')">
                          Move To
                        </app-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  components: {  },
  props: {
    publication: {
      type: Object,
    },
    topicSource: {
      type: Object,
      default: null,
    },
    activeTopic: {
      type: Number,
      default: null,
    },
    activeLearningObject: {
      type: Number,
      default: null,
    },
    activeScreen: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      objState: { topics: _.cloneDeep(this.topicSource) || [] },
    }
  },
  methods: {
    toggleItem(topicIndex, loIndex) {
      if (loIndex !== undefined)
        this.objState.topics[topicIndex].learningObjects[loIndex].open = !this.isItemOpen(topicIndex, loIndex)
      else
        this.objState.topics[topicIndex].open = !this.isItemOpen(topicIndex, loIndex)
    },
    isItemOpen(topicIndex, loIndex) {
      if (loIndex !== undefined) {
        // For learning objects, default to closed.
        return this.objState.topics[topicIndex].learningObjects[loIndex]?.open === true;
      }
      // For topics, default the first one to open.
      return this.objState.topics[topicIndex]?.open === true || (this.objState.topics[topicIndex]?.open === undefined && topicIndex === 0);
    },
  }
}
</script>